import { render } from "./PrizesPage.vue?vue&type=template&id=b4b9ea1e&scoped=true"
import script from "./PrizesPage.vue?vue&type=script&lang=js"
export * from "./PrizesPage.vue?vue&type=script&lang=js"

import "./PrizesPage.vue?vue&type=style&index=0&id=b4b9ea1e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b9ea1e"]])

export default __exports__